import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ChatState, Message } from "../../interfaces/ChatState.ts";

const initialState: ChatState = {
  inputMessage: "",
  conversation: [],
};

export const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    addMessage(state, action: PayloadAction<Message>) {
      return {
        ...state,
        conversation: [...state.conversation, action.payload],
      };
    },
    clearConversation(state) {
      return {
        ...state,
        conversation: [],
      };
    },
    setInputMessage(state, action: PayloadAction<string>) {
      return {
        ...state,
        inputMessage: action.payload,
      };
    },
    clearInputMessage(state) {
      return {
        ...state,
        inputMessage: "",
      };
    },
    setConversation(state, action: PayloadAction<Message[]>) {
      state.conversation = action.payload;
    },
  },
  extraReducers: () => {},
});

export const {
  addMessage,
  clearConversation,
  setInputMessage,
  clearInputMessage,
  setConversation,
} = chatSlice.actions;
export const chatReducer = chatSlice.reducer;
